<nav class="bottom-nav" aria-label="Primary">
  @for (tab of tabs(); track tab.label) {
    @if (isVisible(tab) && tab.route) {
      <a
        class="bottom-nav-link"
        [routerLink]="tab.route"
        routerLinkActive="bottom-nav-link--active"
        [attr.aria-label]="tab.label"
      >
        <span class="bottom-nav-icon-wrap">
          <app-icon [name]="tab.icon" [size]="20" aria-hidden="true" />
        </span>
        <span class="bottom-nav-label">{{ tab.label }}</span>
      </a>
    } @else if (isVisible(tab) && tab.action) {
      <button
        type="button"
        class="bottom-nav-link bottom-nav-link--action"
        (click)="onAction(tab.action)"
        [attr.aria-label]="tab.label"
      >
        <span class="bottom-nav-icon-wrap">
          <app-icon [name]="tab.icon" [size]="20" aria-hidden="true" />
        </span>
        <span class="bottom-nav-label">{{ tab.label }}</span>
      </button>
    }
  }
</nav>
